<div class="container">
  <mat-card>
    <div class="layout-row responsive-column gap-20px">
      <div class="flex-50">
        <mat-nav-list>
          <div #loanProducts>
            <mat-list-item [routerLink]="['loan-products']" *LOSxHasPermission="'READ_LOANPRODUCT'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['loan-products']">
                  <mat-icon matListIcon>
                    <fa-icon icon="briefcase" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Loan Products' | translate }}
                    @if (arrowBooleans[0]) {
                      <p matLine [routerLink]="['loan-products']" class="menu-explanation">
                        {{ 'labels.text.Add new loan product or modify or inactivate loan product' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[0]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(0); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[0]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(0); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #savingsProducts>
            <mat-list-item [routerLink]="['saving-products']" *LOSxHasPermission="'READ_SAVINGSPRODUCT'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['saving-products']">
                  <mat-icon matListIcon>
                    <fa-icon icon="briefcase" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Savings Products' | translate }}
                    @if (arrowBooleans[1]) {
                      <p matLine [routerLink]="['saving-products']" class="menu-explanation">
                        {{ 'labels.text.Add new savings product or modify or inactivate savings product' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[1]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(1); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[1]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(1); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #shareProducts>
            <mat-list-item [routerLink]="['share-products']" *LOSxHasPermission="'READ_SHAREPRODUCT'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['share-products']">
                  <mat-icon matListIcon>
                    <fa-icon icon="briefcase" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Share Products' | translate }}
                    @if (arrowBooleans[2]) {
                      <p matLine [routerLink]="['share-products']" class="menu-explanation">
                        {{ 'labels.text.Add new share product or modify or inactivate share product' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[2]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(2); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[2]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(2); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #charges>
            <mat-list-item [routerLink]="['charges']" *LOSxHasPermission="'READ_CHARGE'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['charges']">
                  <mat-icon matListIcon>
                    <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Charges' | translate }}
                    @if (arrowBooleans[3]) {
                      <p matLine [routerLink]="['charges']" class="menu-explanation">
                        {{
                          'labels.text.Define charges/penalties for loan products, savings and deposit products'
                            | translate
                        }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[3]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(3); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[3]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(3); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <mat-list-item [routerLink]="['collaterals']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['collaterals']">
                <mat-icon matListIcon>
                  <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Collateral Management' | translate }}
                  @if (arrowBooleans[4]) {
                    <p matLine [routerLink]="['collaterals']" class="menu-explanation">
                      {{ 'labels.text.Define collaterals for Collateral Management' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[4]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(4); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[4]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(4); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item
            [routerLink]="['delinquency-bucket-configurations']"
            *LOSxHasPermission="'READ_DELINQUENCY_BUCKET'"
          >
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['delinquency-bucket-configurations']">
                <mat-icon matListIcon>
                  <fa-icon icon="briefcase" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Delinquency Buckets' | translate }}
                  @if (arrowBooleans[5]) {
                    <p matLine [routerLink]="['delinquency-bucket-configurations']" class="menu-explanation">
                      {{ 'labels.text.Define delinquency day ranges and bucket set for loan products' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[5]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(5); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[5]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(5); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['products-mix']" *LOSxHasPermission="'READ_PRODUCTMIX'">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['products-mix']">
                <mat-icon matListIcon>
                  <fa-icon icon="random" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Products Mix' | translate }}
                  @if (arrowBooleans[6]) {
                    <p matLine [routerLink]="['products-mix']" class="menu-explanation">
                      {{ 'labels.text.Defines rules for taking multiple rules' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[6]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(6); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[6]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(6); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <div #fixedDepositProducts>
            <mat-list-item [routerLink]="['fixed-deposit-products']" *LOSxHasPermission="'READ_FIXEDDEPOSITPRODUCT'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['fixed-deposit-products']">
                  <mat-icon matListIcon>
                    <fa-icon icon="briefcase" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Fixed Deposit Products' | translate }}
                    @if (arrowBooleans[7]) {
                      <p matLine [routerLink]="['fixed-deposit-products']" class="menu-explanation">
                        {{ 'labels.text.Add, modify or inactivate a Fixed deposit product' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[7]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(7); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[7]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(7); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #recurringDepositProducts>
            <mat-list-item
              [routerLink]="['recurring-deposit-products']"
              *LOSxHasPermission="'READ_RECURRINGDEPOSITPRODUCT'"
            >
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['recurring-deposit-products']">
                  <mat-icon matListIcon>
                    <fa-icon icon="briefcase" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Recurring Deposit Products' | translate }}
                    @if (arrowBooleans[8]) {
                      <p matLine [routerLink]="['recurring-deposit-products']" class="menu-explanation">
                        {{ 'labels.text.Add, modify or inactivate a Recurring Deposit product' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[8]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(8); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[8]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(8); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <mat-list-item [routerLink]="['tax-configurations']" *LOSxHasPermission="'READ_TAXGROUP'">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['tax-configurations']">
                <mat-icon matListIcon>
                  <fa-icon icon="cogs" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Manage Tax Configurations' | translate }}
                  @if (arrowBooleans[9]) {
                    <p matLine [routerLink]="['tax-configurations']" class="menu-explanation">
                      {{ 'labels.text.Define Tax components and Tax groups' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[9]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(9); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[9]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(9); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [routerLink]="['floating-rates']" *LOSxHasPermission="'READ_FLOATINGRATE'">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['floating-rates']">
                <mat-icon matListIcon>
                  <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Floating Rates' | translate }}
                  @if (arrowBooleans[10]) {
                    <p matLine [routerLink]="['floating-rates']">
                      {{ 'labels.text.Define floating rates for loan products' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[10]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(10); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[10]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(10); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>

<ng-template #templateCharges let-popover="popover">
  <h2>{{ 'labels.heading.Charges' | translate }}</h2>
  <p class="mw400">{{ 'labels.text.Two types of charges—fees and penalties' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      Close
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepCharges()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepCharges()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateLoanProducts let-popover="popover">
  <h2>{{ 'labels.heading.Loan Products' | translate }}</h2>
  <p class="mw400">{{ 'labels.text.Loan products define the rules, default settings' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepLoanProducts()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepLoanProducts()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateSavingsProducts let-popover="popover">
  <h2>{{ 'labels.heading.Savings Products' | translate }}</h2>
  <p class="mw400">{{ 'labels.text.Savings products define the rules, default settings' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepSavingsProducts()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepSavingsProducts()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateShareProducts let-popover="popover">
  <h2>{{ 'labels.heading.Share Products' | translate }}</h2>
  <p class="mw400">{{ 'labels.text.Share products define the rules, default settings' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepShareProducts()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepShareProducts()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateFixedDepositProducts let-popover="popover">
  <h2>{{ 'labels.heading.Fixed Deposit Products' | translate }}</h2>
  <p class="mw400">{{ 'labels.text.Fixed Deposit Products defines the rules, default settings' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepFixedDepositProducts()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepFixedDepositProducts()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateRecurringDepositProducts let-popover="popover">
  <h2>{{ 'labels.heading.Recurring Deposit Products' | translate }}</h2>
  <p class="mw400">{{ 'labels.text.Recurring Deposit products define the rules, default settings' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepRecurringDepositProducts()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepRecurringDepositProducts()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
